import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import {
  AbsDropdownModule,
  AbsFlyoutModule,
  AbsTooltipModule,
  AbsLoaderAnimationModule,
  AbsFormsModule,
  AbsModalsAndAlertsModule,
  AbsTablesModule,
  AbsUtilitiesModule,
  AbsPaginationModule,
  AbsExpandCollapseModule,
  AbsSwitchModule,
  AbsMessagesModule,
  AbsCardsModule
} from '@att-ebiz/abs-components-bc';
import { CfetCoreModule } from '../cfet-core/cfet-core.module';
import { CfetSharedModule } from '../cfet-shared/cfet-shared.module';
import { CancelModalUtfComponent } from '../cfet-shared';
import {
  CustomerEligibilityFormComponent, CustomerEligibilityWorkplaceComponent, CustomerEligibilityCompletionComponent,
  CustomerIneligibilityComponent, DontSeeYourWorkplaceFormComponent, CustomerInformationFormComponent,
  CustomerInstantVerificationComponent, CustomerInstantVerificationUtfComponent, CustomerDocumentsUploadComponent,
  CustomerDocumentsUploadUtfComponent, CustomerVerificationPendingComponent, CustomerVerificationPendingUtfComponent,
  CustomerNoVerificationRequiredComponent, CustomerNoVerificationRequiredUtfComponent, AccordionModalPopupComponent,
  FileConfirmationDeleteModalComponent, FileConfirmationDeleteModalUtfComponent, CustomerProfileFormComponent,
  CustomerProfileUtfFormComponent, CompleteProfileFormComponent, CompleteProfileUtfFormComponent,
  CustomerDocumentsReviewComponent, CustomerDocumentsReviewUtfComponent, CompleteProfileConfirmationComponent,
  CompleteProfileConfirmationUtfComponent, CustomerCancelModalComponent, SkipForNowModalComponent, SkipForNowModalUtfComponent,
  UtfRegistrationVerifyFormComponent, CustomerEligibilityUtfFormComponent, CustomerEligibilityUtfCompletionComponent,
  CustomerEligibilityUtfWorkplaceComponent, CustomerIneligibilityUtfComponent, DontSeeYourWorkplaceUtfFormComponent,
  CustomerInformationFormUtfComponent, ProgressTrackerComponent, UtfAuthLandingPageComponent, UtfAuthSingleIdHomepageComponent,
  UtfUnauthPageFormComponent, UtfAuthSeparateIdFormComponent, UtfSyncInfoPageComponent,
  UtfSyncingInformationPageComponent
} from './index';

@NgModule({
  declarations: [
    CustomerEligibilityFormComponent,
    CustomerEligibilityWorkplaceComponent,
    CustomerEligibilityCompletionComponent,
    CustomerIneligibilityComponent,
    DontSeeYourWorkplaceFormComponent,
    CustomerInformationFormComponent,
    CustomerInstantVerificationComponent,
    CustomerInstantVerificationUtfComponent,
    CustomerDocumentsUploadComponent,
    CustomerDocumentsUploadUtfComponent,
    CustomerVerificationPendingComponent,
    CustomerVerificationPendingUtfComponent,
    CustomerNoVerificationRequiredComponent,
    CustomerNoVerificationRequiredUtfComponent,
    AccordionModalPopupComponent,
    FileConfirmationDeleteModalComponent,
    FileConfirmationDeleteModalUtfComponent,
    CustomerProfileFormComponent,
    CustomerProfileUtfFormComponent,
    CompleteProfileFormComponent,
    CompleteProfileUtfFormComponent,
    CustomerDocumentsReviewComponent,
    CustomerDocumentsReviewUtfComponent,
    CompleteProfileConfirmationComponent,
    CompleteProfileConfirmationUtfComponent,
    CustomerCancelModalComponent,
    SkipForNowModalComponent,
    SkipForNowModalUtfComponent,
    UtfRegistrationVerifyFormComponent,
    CustomerEligibilityUtfFormComponent,
    CustomerEligibilityUtfCompletionComponent,
    CustomerEligibilityUtfWorkplaceComponent,
    CustomerIneligibilityUtfComponent,
    DontSeeYourWorkplaceUtfFormComponent,
    CustomerInformationFormUtfComponent,
    ProgressTrackerComponent,
    CancelModalUtfComponent,
    UtfAuthLandingPageComponent,
    UtfAuthSingleIdHomepageComponent,
    UtfUnauthPageFormComponent,
    UtfAuthSeparateIdFormComponent,
    UtfSyncInfoPageComponent,
    UtfSyncingInformationPageComponent
  ],
  imports: [
    CommonModule,
    CfetCoreModule,
    CfetSharedModule,
    ReactiveFormsModule,
    AbsDropdownModule,
    AbsFormsModule,
    AbsFlyoutModule,
    AbsTooltipModule,
    AbsLoaderAnimationModule,
    AbsModalsAndAlertsModule,
    AbsTablesModule,
    AbsUtilitiesModule,
    AbsPaginationModule,
    FormsModule,
    AbsExpandCollapseModule,
    AbsSwitchModule,
    AbsMessagesModule,
    AbsCardsModule
  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA
  ],
  exports: [
    CustomerEligibilityFormComponent,
    CustomerEligibilityUtfFormComponent,
    CustomerInformationFormComponent,
    CustomerInformationFormUtfComponent,
    CustomerProfileFormComponent,
    CustomerProfileUtfFormComponent,
    CompleteProfileFormComponent,
    CompleteProfileUtfFormComponent,
    CompleteProfileConfirmationComponent,
    CompleteProfileConfirmationUtfComponent,
    UtfRegistrationVerifyFormComponent,
    UtfAuthLandingPageComponent,
    UtfAuthSingleIdHomepageComponent,
    UtfUnauthPageFormComponent,
    ProgressTrackerComponent,
    UtfSyncInfoPageComponent,
    UtfSyncingInformationPageComponent
  ],
  providers: [
    DatePipe
  ]
})
export class CfetPageComponentsModule { }
